export default {
    edit: 'Edit trend radar'
}
